import mixpanel from 'mixpanel-browser';

mixpanel.init(
    import.meta.env.VITE_MIXPANEL_TOKEN || '',
    {
        debug: import.meta.env.DEV,
    }
);

export default mixpanel;